<template>   
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>
    <b-row class="text-center">
        <b-col cols="12">          
          <div style="margin-bottom:10px"></div>
             <b-col lg="12" class="my-1">
              <b-form-group
                label="Pesquisar"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Nome ou Número da sala"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <div style="margin: 10px"></div>
              <b-card bg-variant="light" style="min-height: 60vh;">
                <div class="col-md-12">                   
                    <div class="overflow-auto">
                      <b-table stacked="md" id="my-table" @filtered="onFiltered" :filter="filter" :filter-included-fields="filterOn" striped small :fields="fields" :items="salas" responsive="sm"  :per-page="perPage" :current-page="currentPage">
                        <template  v-slot:cell(codigo)="data">
                           <span>{{data.item.idSala}}</span>                                         
                        </template>
                        <template  v-slot:cell(descricao)="data">
                           <span>{{data.item.descricaoCompleta}}</span>                                         
                        </template>
                        <template  v-slot:cell(visualizar)="data">
                            <b-button @click="visualizar(data.item.idSala)" class="v-button" size="sm" style="background-color: #303f9f; margin-right: 5px;"><b-icon icon="search"></b-icon></b-button>                                         
                            <b-button @click="remover(data.item.idSala)" class="v-button" size="sm" variant="danger"><b-icon icon="trash"></b-icon></b-button>                                                                                  
                        </template>
                      </b-table>
                      <div style="float: right">
                        <b-pagination
                        size="sm"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        ></b-pagination>
                      </div>                      
                    </div>
                </div>
              </b-card>
              <br>
              <b-card bg-variant="light">
                <div class="row" style="float: right">
                    <b-button v-b-modal.modal-sala style="margin-right: 30px; background-color: #303f9f">
                      <b-icon icon="file-earmark"></b-icon>  Novo
                    </b-button>   
                </div>
              </b-card>
        </b-col>
      </b-row>
      <b-modal id="modal-sala" ref="modal" :title="sala.idSala == '' ? 'Novo Sala' : 'Edição Sala'" @hidden="resetModal" @ok="salvar" >
                <b-form-group label="Descrição" label-for="name-input"  >
                    <b-input id="name-input" v-model="sala.descricao" ></b-input>
                </b-form-group>
                <b-form-group label="Nº" label-for="name-input"  >
                    <b-input id="name-input" type="number" v-model="sala.numeroSala" ></b-input>
                </b-form-group>
                <b-form-group label="Complemento" label-for="name-input"  >
                    <b-input id="name-input" v-model="sala.complemento" ></b-input>
                </b-form-group>
        </b-modal>  
    </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';

export default {
  components: { BarraNavegacao },

  data(){
    return{
      salas: [],
      fields: [{ key: 'descricao', label: 'Descrição' , class:'text-center',sortByFormatted: true},{ key: 'visualizar', label: 'Visualizar' , class:'text-center'}],
      sala: {idSala: null, descricao: '', numeroSala: '', status: 'A'},
      perPage: 10,
      currentPage: 1,
      rows: 10000,
      filter: null,
      filterOn: [],
    }
  },

  created(){
    this.validaAcesso();
  },

  mounted(){
  
    this.listar();

  },

  methods: {

    alertaMensager(mensagem,titulo,tipo){
          this.$fire({
              title: titulo,
              text: mensagem,
              type: tipo,
              }).then(r => {
               r.value;
            });
        },

    resetModal() {
        this.sala= {idSala: null, descricao: '', status: 'A'}
    },

    salvar(){
        this.$http.post('/sala', this.sala).then(res => {
             this.alertaMensager(res.data,"","success");   
             this.listar();      
          })
    },

    validaAcesso(){
        this.$http.get('/gerencia', this.sala).then()
    },

    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows = filteredItems.length
        this.currentPage = 1
    },

    listar(){
      this.$http.get("/sala").then(res => {
         this.salas = res.data;
         this.rows = this.salas.length;
      }) 
    },

    visualizar(id){
      this.$http.get("/sala/"+id).then(res => {
         this.sala = res.data;
         this.$bvModal.show('modal-sala');
      }) 
    },

    remover(id){
        this.$confirm("Tem certeza que deseja excluir a sala ?").then(() => {
            this.$http.delete("/sala/"+id).then(res => {
                if(res.status == 200){
                    this.alertaMensager("",res.data,"success");
                }else{
                    this.alertaMensager("",res.data,"error");
                }
                
            }) 
        });
      
    }
    
    
  }
}

</script>

<style>

</style>
